import React from 'react';
import styles from './FormField.module.css';

interface FormFieldProps {
	label: string;
	icon: React.ReactNode;
	value: string;
	onChange: (value: string) => void;
	onBlur: () => void;
	error?: string;
	touched?: boolean;
	disabled?: boolean;
	type?: string;
	placeholder?: string;
	maxLength?: number;
}

export const FormField = ({
	label,
	icon,
	value,
	onChange,
	onBlur,
	error,
	touched,
	disabled,
	type = 'text',
	placeholder,
	maxLength,
}: FormFieldProps) => {
	return (
		<div className={styles.field}>
			<label className={styles.label}>
				{icon}
				{label}
			</label>
			<input
				type={type}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				onBlur={onBlur}
				className={`${styles.input} ${error && touched ? styles.inputError : ''}`}
				disabled={disabled}
				placeholder={placeholder}
				maxLength={maxLength}
			/>
			<div className={styles.errorContainer}>
				{error && touched && <span className={styles.error}>{error}</span>}
			</div>
		</div>
	);
};
